import * as React from "react";

const SvgDrizzle = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="Drizzle_svg__a">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Drizzle_svg__b">
        <path d="M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 0 1 0 3z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Drizzle_svg__c">
        <path d="M757.955 220.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 0 1 0 3z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Drizzle_svg__d">
        <path d="M741.455 212.954a1.5 1.5 0 1 1 0-3h20a1.5 1.5 0 0 1 0 3z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Drizzle_svg__e">
        <path d="M767.955 212.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 0 1 0 3z" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#Drizzle_svg__a)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -964.217 364.43)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.663-10.664 10.663-.037 0-.073-.005-.109-.005-.949 8.504-8.158 15.116-16.915 15.116-6.916 0-12.864-4.125-15.529-10.048-.084.002-.167.006-.252.006-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(776.833 228.252)"
        />
      </g>
    </g>
    <g
      clipPath="url(#Drizzle_svg__b)"
      style={{
        fill: "#00b3f0",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -964.217 364.43)"
    >
      <g
        style={{
          fill: "#00b3f0",
          fillOpacity: 1,
        }}
      >
        <path
          d="M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 0 1 0 3z"
          style={{
            fill: "#00b3f0",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#Drizzle_svg__c)"
      transform="matrix(1.33333 0 0 -1.33333 -964.217 364.43)"
    >
      <g
        style={{
          fill: "#00b3f0",
          fillOpacity: 1,
        }}
      >
        <path
          d="M757.955 220.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 0 1 0 3z"
          style={{
            fill: "#00b3f0",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#Drizzle_svg__d)"
      style={{
        fill: "#00b3f0",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -964.217 364.43)"
    >
      <g
        style={{
          fill: "#00b3f0",
          fillOpacity: 1,
        }}
      >
        <path
          d="M741.455 212.954a1.5 1.5 0 1 1 0-3h20a1.5 1.5 0 0 1 0 3z"
          style={{
            fill: "#00b3f0",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#Drizzle_svg__e)"
      style={{
        fill: "#00b3f0",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -964.217 364.43)"
    >
      <g
        style={{
          fill: "#00b3f0",
          fillOpacity: 1,
        }}
      >
        <path
          d="M767.955 212.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 0 1 0 3z"
          style={{
            fill: "#00b3f0",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 530.889 -395.904)"
      d="M-398.167 296.928h72v72h-72z"
    />
  </svg>
);

export default SvgDrizzle;
